import React from 'react';
import { StyledLayoutItem } from './index.styles.js';
import {} from '@oneaudi/unified-web-common';
export const LayoutItem = React.forwardRef(({ align = 'flex-start', basis = 'auto', children, grow = '0', shrink = '1', role, className, 'data-testid': dataTestId, margin }, ref) => {
    return (React.createElement(StyledLayoutItem, { align: align, basis: basis, grow: grow, ref: ref, shrink: shrink, role: role, margin: margin, "data-testid": dataTestId, className: className }, children));
});
LayoutItem.displayName = 'LayoutItem';
//# sourceMappingURL=index.js.map